import { useNavigate as useReactRouterNavigate, useParams, NavigateFunction } from 'react-router-dom';

/**
 * Hook customizado para navegação que preserva o prefixo /:state/:city quando presente
 * Substituto direto do useNavigate do react-router-dom com suporte a multi-tenant
 */
export const useNavigate = (): NavigateFunction => {
  const navigate = useReactRouterNavigate();
  const params = useParams<{ state?: string; city?: string }>();

  const navigateWithPrefix: NavigateFunction = (to: any, options?: any) => {
    // Se "to" for um número (navegação relativa como -1, -2), usa diretamente
    if (typeof to === 'number') {
      return navigate(to);
    }

    // Se "to" for um objeto ou se não tiver prefixo state/city, usa navegação normal
    if (typeof to !== 'string' || !params.state || !params.city) {
      return navigate(to, options);
    }

    // Se a rota começa com http ou #, usa navegação normal
    if (to.startsWith('http') || to.startsWith('#')) {
      return navigate(to, options);
    }

    // Remove barra inicial se existir
    const cleanPath = to.startsWith('/') ? to.substring(1) : to;

    // Adiciona o prefixo state/city
    const pathWithPrefix = `/${params.state}/${params.city}/${cleanPath}`;

    return navigate(pathWithPrefix, options);
  };

  return navigateWithPrefix as NavigateFunction;
};
